import matchHeight from 'jquery-match-height';

(function( $ ) {
  
  if ($('.products .product').length > 0) {
    $('.products .product').matchHeight();
  }

  if ($('.wc-block-grid__products').length > 0) {
    $('.wc-block-grid__products .wc-block-grid__product').matchHeight();
  }
  
	$(window).on('load resize', function() {
		if ($('.products .product').length > 0) {
			$('.products .product').matchHeight();
		}

    if ($('.wc-block-grid__products').length > 0) {
			$('.wc-block-grid__products .wc-block-grid__product').matchHeight();
    }
	});

	if ($('.billing_invoice input').length > 0) {
		$('.billing_invoice input').change(function(){
			if($('.billing_invoice input').is(':checked')) {
				$('.billing_invoice_field').slideDown();
			} else {
				$('.billing_invoice_field').slideUp();
			}
		});
	}

	$('.sidebar-menu a.active').closest('li').addClass('open');

  // category description 
  $('.term-description .show-more').click(function(){
    $(this).hide();
    $('.term-description .more').slideDown();
  });
})(jQuery);


// WEBPACK FOOTER //
// ./resources/js/partials/woocommerce.js